import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActionsFilters } from '../../actions/actions-filter/actions-filter.interface';
import { UtilsService } from '../../shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NetworkedUsersSelectorComponent } from '../../shared/networked-users-selector/networked-users-selector.component';
import { RBACService } from '../../shared/rbac.service';

@Component({
  selector: 'app-assets-view-corrective-actions-filter',
  templateUrl: './assets-view-corrective-actions-filter.component.html',
  styleUrls: ['./assets-view-corrective-actions-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssetsViewCorrectiveActionsFilterComponent implements OnInit {
  filters: ActionsFilters = {
    assigned_users: [],
    priority: '',
    status: '0',
    type: '',
    date_range: []
  } as ActionsFilters;

  // The assigned users filter lists networked users, so it needs that feature's view permission.
  // Resolved once in ngOnInit().
  canViewNetworkedUsers: boolean = false;

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetsViewCorrectiveActionsFilterComponent>,
    public rbac: RBACService
  ) {}

  ngOnInit() {
    this.canViewNetworkedUsers = this.rbac.userCanAccess([
      RBACService.getPermission(RBACService.RBAC_F.F_NETWORKED_USERS, RBACService.RBAC_A.A_VIEW)
    ], true);

    // Set default values if not provided.
    this.filters.assigned_users = this.data['assigned_users'] || [];
    this.filters.priority = this.data['priority'] || '';
    this.filters.status = (this.data['completed'] || 0).toString();
    this.filters.type = this.data['type'] || '';
    this.filters.date_range = this.data['date_range'] || '';
  }

  /**
   * Select networked users and update the user IDs filters.
   *
   * @return {void}
   */
  onSelectUsers(): void {
    if (!this.canViewNetworkedUsers) {
      this.rbac.showGenericAccessDeniedMessage('You do not have permission to view networked users.');
      return;
    }

    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      {
        selected: this.filters.assigned_users,
        multiple: true,
        visitors_from_all_sites: true
      },
      {
        width: '1200px'
      },
      (results: any): void => {
        if (typeof results != 'undefined') {
          this.filters.assigned_users = results;
        }
      }
    );
  }

  /**
   * Sets the output date range based on the provided event value.
   *
   * @param {any} event - The event value to set the date range.
   * @return {void} - No return value.
   */
  getOutputDateRange(event: any): void {
    this.filters.date_range = event;
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.assigned_users = [];
    this.filters.priority = '';
    this.filters.status = '0';
    this.filters.type = '';
    this.filters.date_range = [];

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      assigned_users: this.filters.assigned_users,
      priority: this.filters.priority,
      completed: Number(this.filters.status),
      type: this.filters.type,
      date_range: this.filters.date_range
    };

    this.dialogRef.close(response);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Clears the date range for this filter.
   *
   * @returns {void}
   */
  onClearDateRange(): void {
    this.filters.date_range = [];
  }
}
